import { useEffect } from 'react';

/**
 * Buying power has to be re-read from OMS whenever an order result modal becomes
 * visible, because the order that just settled may have changed it.
 */
const useRefreshBuyingPower = (isResultModalVisible: boolean, refreshBuyingPower: () => void) => {
  useEffect(() => {
    if (isResultModalVisible) {
      refreshBuyingPower();
    }
  }, [isResultModalVisible]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useRefreshBuyingPower;
